import Vue from 'vue'
import vuetify from './plugins/vuetify'
import App from './App'
import router from './router'
import store from './store'
import services from './services'
import VueAnalytics from 'vue-analytics'
import { GOOGLE_ANALYTICS_ID } from 'utils/constants'
import VeeValidate from 'vee-validate'
import validationMessagesPtBR from 'vee-validate/dist/locale/pt_BR'
import validationMessagesEn from 'vee-validate/dist/locale/en'
import VueMeta from 'vue-meta'
import GMaps from './libs/gmaps/config'
import i18n from './i18n'
import { components } from 'corp-front-vue-commons'
import './filters'

Object.keys(services).forEach(service => Vue.use(services[service]))

components.forEach(({ name, config }) => {
  Vue.component(name, config)
})

Vue.use(VeeValidate, {
  events: 'change|blur|submit',
  i18nRootKey: 'validations',
  i18n,
  dictionary: {
    pt_BR: validationMessagesPtBR,
    en: validationMessagesEn
  }
})

Vue.use(VueMeta, {
  keyName: 'metaInfo',
  attribute: 'data-vue-meta',
  ssrAttribute: 'data-vue-meta-server-rendered',
  tagIDKeyName: 'vmid',
  refreshOnceOnNavigation: true
})

Vue.use(VueAnalytics, {
  id: GOOGLE_ANALYTICS_ID,
  router,
  ignoreRoutes: ['Login'],
  checkDuplicatedScript: true,
  debug: {
    enabled: false,
    trace: false,
    sendHitTask: process.env.NODE_ENV === 'production'
  }
})

Vue.use(GMaps)

Vue.config.productionTip = false

new Vue({
  router,
  store,
  i18n,
  vuetify,
  render: h => h(App)
}).$mount('#app')
